import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import i18n from 'i18next';
// import TagManager from 'react-gtm-module';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Events } from './services/EventService';
import './i18n';
// import Telemetry from './services/boot/Telemetry';
// import AppService from './services/AppService';
// import TelemetryService from './services/TelemetryService';
// import TelemetryConstants from './constants/TelemetryConstants';
// import UserPrefService from './services/UserPrefService';
// import ABTestService from './services/ABTestService';
// import ABTests from './constants/ABTests';
import 'bootstrap/dist/css/bootstrap.min.css';
// import blitz from 'blitzllama-js';

// real user monitoring within the elastic APM.
// import { init as initApm } from '@elastic/apm-rum';
// var apm = initApm({
//   serviceName: 'mitra-pwa',
//   serverUrl: 'https://realusermonitoring.vahan.co',
//   serviceVersion: '__MITRA_PWA_APM_VERSION__',
//   environment: process.env.NODE_ENV,
//   active: process.env.NODE_ENV === 'production'
// })
// blitz.init('key_Bm7b3o2IMpAuxIh');

require('intersection-observer');

// const tagManagerArgs = {
//   gtmId: process.env.REACT_APP_GTM_ID,
// };

// TagManager.initialize(tagManagerArgs);

// eslint-disable-next-line no-undef
window.Moengage = moe({
  app_id: 'A7BUJ1RRESMUMVUOLEOLJ1XD',
  debug_logs: process.env.NODE_ENV === 'production' ? 0 : 1,
});

window.Moengage.call_web_push({
  soft_ask: false,
  main_class: 'moe-main-class',
  allow_class: 'moe-allow-class',
  block_class: 'moe-block-class',
});
const initialHeight = window.innerHeight;
window.onresize = () => {
  if (window.innerHeight < initialHeight) {
    document.documentElement.style.setProperty('overflow', 'auto');
    const metaViewport = document.querySelector('meta[name=viewport]');
    metaViewport.setAttribute(
      'content',
      `height=${initialHeight}px, width=device-width, initial-scale=1.0`
    );
  } else {
    const metaViewport = document.querySelector('meta[name=viewport]');
    metaViewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'
    );
  }
};
// ABTestService.initializeTests();
// AppService.getAndSetTreatmentFlag();
// AppService.getAndSetUTMSource();
// AppService.getAndSetFacebookAllDetailsFlag();
// const landingPageLanguage = AppService.getAndSetLanguageLandingPageFlag();
window.eventemitter = new Events();
// const { language } = UserPrefService.readPref();
// window.activeLanguage = language || localStorage.getItem('i18nextLng') || 'en';
window.addEventListener('beforeinstallprompt', e => {
  console.log('beforeinstallprompt');
  // Prevent Chrome 67 and earlier from automatically showing the
  e.preventDefault();
  // Stash the event so it can be triggered later.
  window.deferredPrompt = e;
});

// const fade = element => {
//   const elem = element;
//   let op = 1; // initial opacity
//   const timer = setInterval(function() {
//     if (op <= 0.1) {
//       clearInterval(timer);
//       elem.style.display = 'none';
//     }
//     elem.style.opacity = op;
//     elem.style.filter = `alpha(opacity=${op * 100})`;
//     op -= op * 0.1;
//   }, 15);
// };

// Telemetry.boot((err, data) => {
//   console.log('Telemetry booted', err, data);
//   console.log(window.location.hash);
//   const hash = `${window.location.pathname}`;
//   console.log('window.location: ', hash);
//   const urlString = window.location.href;
//   const url = new URL(urlString);
//   localStorage.setItem('initialUrl', url);
//   // const urlLanguage = url.searchParams.get('language');
//   const showOnboarding = hash === '/';
//   const inNewLandingPageTreatmentGroup =
//     ABTestService.getABTestVariant(ABTests.NEW_LADING_PAGE_TEST.name) ===
//     ABTests.NEW_LADING_PAGE_TEST.variants[1];
//   if (showOnboarding && !inNewLandingPageTreatmentGroup) {
//     const landingPageDivId = 'static-new-design';
//     const landingPage = document.getElementById(landingPageDivId);
//     // TODO: Add instrumentation for new landing page
//     const root = document.getElementById('root');
//     root.style.height = '0%';
//
//     i18n.init({ lng: landingPageLanguage }, () => {
//       document.getElementById('mitra-app-desciption').innerHTML = i18n.t(
//         'landing_page_description_text'
//       );
//       document.getElementById('proceed-new-design').innerHTML = i18n.t(
//         'landing_page_get_a_job_text'
//       );
//       landingPage.hidden = false;
//       // const btn = document.getElementById('proceed');
//       TelemetryService.sendEvent([
//         TelemetryConstants.ONBOARDING,
//         TelemetryConstants.VALUE_PROPOSITION,
//         TelemetryConstants.PAGE_LOAD,
//       ]);
//     });
//
//     setTimeout(() => {
//       fade(document.getElementById('splash-screen'));
//     }, 3000);
//
//     landingPage.addEventListener('click', () => {
//       // disabling routes to onboarding page
//       // TelemetryService.sendEvent([
//       //   TelemetryConstants.ONBOARDING,
//       //   TelemetryConstants.VALUE_PROPOSITION,
//       //   TelemetryConstants.START_SEARCH,
//       // ]);
//       // landingPage.hidden = true;
//       // root.style.height = '100%';
//       // ReactDOM.render(<App />, root);
//     });
//   } else if (showOnboarding && inNewLandingPageTreatmentGroup) {
//     const landingPageDivId = 'static-new-design-2';
//     const landingPage = document.getElementById(landingPageDivId);
//     const root = document.getElementById('root');
//     root.style.height = '0%';
//     document.getElementById('languageChange').value = landingPageLanguage;
//     i18n
//       .init({ lng: landingPageLanguage }, () => {
//         document.getElementById('mitra-app-desciption-2').innerHTML = i18n.t(
//           'landing_page_description_text_new'
//         );
//         document.getElementById('proceed-new-design-2').innerHTML = i18n.t(
//           'landing_page_get_a_job_text_new'
//         );
//         landingPage.hidden = false;
//         TelemetryService.sendEvent([
//           TelemetryConstants.ONBOARDING,
//           TelemetryConstants.VALUE_PROPOSITION,
//           TelemetryConstants.PAGE_LOAD,
//         ]);
//       })
//       .then(() => {
//         document.getElementById('languageChange').addEventListener('change', function() {
//           const selectedLanguage = this.value;
//           i18n.changeLanguage(selectedLanguage).then(() => {
//             window.prevLang = window.activeLanguage;
//             window.activeLanguage = i18n.language;
//             document.getElementById('mitra-app-desciption-2').innerHTML = i18n.t(
//               'landing_page_description_text_new'
//             );
//             document.getElementById('proceed-new-design-2').innerHTML = i18n.t(
//               'landing_page_get_a_job_text_new'
//             );
//             AppService.getAndSetLanguageLandingPageFlag(i18n.language);
//           });
//         });
//         document.getElementById('proceed-new-design-2').addEventListener('click', () => {
//           // TelemetryService.sendEvent([
//           //   TelemetryConstants.ONBOARDING,
//           //   TelemetryConstants.VALUE_PROPOSITION,
//           //   TelemetryConstants.START_SEARCH,
//           // ]);
//           // landingPage.hidden = true;
//           // root.style.height = '100%';
//           // ReactDOM.render(<App />, root);
//         });
//       });
//
//     setTimeout(() => {
//       fade(document.getElementById('splash-screen-2'));
//     }, 3000);
//   } else {
//     const root = document.getElementById('root');
//     root.style.height = '100%';
//     ReactDOM.render(<App />, root);
//   }
// });

const root = document.getElementById('root');
ReactDOM.render(<App />, root);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
